import React, { useEffect, useRef, useState } from "react";
import Header from "@/components/Header";
import bwmodel from '@/config/bwmodel';
import styled from "styled-components";
import awardImg from './image/award.png';
import cardImg from './image/card.png';
import bg2 from './image/bg2.png';
import bg1 from './image/bg1.png';
import title1 from './image/1@2x.png';
import title2 from './image/2@2x.png';
import title3 from './image/3@2x.png';
import bridge from '@/config/JSbridge'
import Reward from './components/reward';
import Explain from './components/explain';
import Originator from './components/Originator';
import Content from './content';
import moment from 'moment';
import h5Share from '@/utils/h5Share'
import Participate from './components/participate'
import { connect } from 'react-redux';
import { fetchComplexranking, fetchTopicList } from './api'
import { jumpTo } from '@/utils'
import OpenApp from '../../components/OpenApp';
import { handleUploadTrace } from "@/utils";
import { getActivityUserInfo } from '@/api/user-new'

export const isStorm = bwmodel.app === 'storm';

const Million = ({token}) => {
  const active_id = 130;
  console.log(active_id);
  
  const [userList, setUserList] = useState([]);
  const [havePoints, setHavePoints] = useState(false);

  const [selfRank, setSelfRank] = useState(0);
  const [activeList, setActiveList] = useState(1);
  const [topicList, setTopicList] = useState([]);
  const [rankDate, setRankDate] = useState({});
  const [userInfo, setUserInfo ] = useState({})
  const [isLogin, setIsLogin] = useState(false)
  // const shareRef = useRef()
  const ruleRef = useRef(null);
  const participateRef = useRef(null);
  function getMonthDateRange() {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();

    // 本月第一天
    const firstDayOfMonth = new Date(year, month, 1);
    // 本月最后一天
    const lastDayOfMonth = new Date(year, month + 1, 0);

    // 下月第一天
    const firstDayOfNextMonth = new Date(year, month + 1, 1);
    const lastDayOfNextMonth = new Date(year, month + 2, 0);

    setRankDate({
      firstDayOfMonth: moment(firstDayOfMonth).format('MM.DD'),
      lastDayOfMonth: moment(lastDayOfMonth).format('MM.DD'),
      firstDayOfNextMonth: moment(firstDayOfNextMonth).format('MM.DD'),
      lastDayOfNextMonth: moment(lastDayOfNextMonth).format('MM.DD'),
      time: moment(lastDayOfMonth).format('MM.DD 23.59.59')
    })
  }
  useEffect(()=> {
    getData()
  },[])

  useEffect(()=> {
    // 是否首次弹框
    const isFirst = localStorage.getItem('isFirst')
    if(!isFirst) {
      localStorage.setItem('isFirst',1)
      participateRef.current.show();
    }
  
  },[])

  let getData = () => {
    getActivityUserInfo(22).then(res => {
      let info = {
        user: res.user || {}
      }
      setUserInfo(info.user)
      
      // 重新设置分享信息
      // setShareLinkParams(info)

      if(!res.user) {
        setIsLogin(false);
        console.log(isLogin);
        
      }
      // setOverTime(parseInt(endTime.diff(startTime) / 1000, 10))
    }).catch((error) => {

      let res = error.response
      if (res && res.status === 401) {
        setIsLogin(false);
       
      }
    })
  }
  const handleLogin = (cb) => {
    if(!isStorm) {
      window.location.href = "https://m.wogoo.com/app/download/wogoo_client/index.html"
    }
    bridge.callHandler(
      'nativeEvent',
      {
        event: 'login',
        params: {
          refreshOnBack: true
        }
      },
      () => {}
    );
  }
   function goEidt(content) {
    handleUploadTrace('Million_Create_Click', 'click')
    if(!token) {
      return  handleLogin()
    } 
    

    const text = content ? `#${content}#`:''
    bridge.callHandler('nativeEvent', {
      event: 'openPublishForumEvent',
      params: {
        text: text,
        // imageBase64: str
      }
    }, res => {
    })
  }
  const bodyContainer = useRef()
 
  useEffect(()=> {
    h5Share.main({ 
      title: `市值风云创作者百万补贴`,
      desc: '全民创作计划火爆进行中，月月可得3000元现金奖励',
      link: process.env.REACT_APP_DEMAND_URL + 'active_130',
      thumbUrl: 'https://file.wogoo.com/app/logo/logo6.png',
      wxShare:{
        shareData:{
          imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
        }
      }
    })
    handleUploadTrace('Million_Home_Exposure', 'visitor')
        // 修复安卓软键盘遮挡问题
    bridge.callHandler('nativeEvent', {
      event: 'web_softinput_resize',
      params: {
        isImmersed: true
      }
    }, res => {})

    
    getMonthDateRange();

    var today = new Date();
    var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
     const params = {
      "category": 1,
      "pageNo": 1,
      "pageSize":10,
      "statisticsDate": moment(firstDay).format('YYYY-MM-DD'),
      "stockCode": "2"
    }
    console.log('firstDay',params);
    
    fetchComplexranking(params)
      .then(res => {
        const list = res.data.slice(0, 3);
        const havePoints = res.havePoints;
        // selfRank
        setUserList(list)
        setHavePoints(havePoints)
        setSelfRank(res.selfRank)
        
      })
  },[])
   useEffect(()=> {
      const params = {
        "maxCount": 999,
        "term": ""
      }
      fetchTopicList(params)
        .then(res => {
          const list = res.content.slice(0,3)
          setTopicList(list)
        })
     
 },[])


  const setShareLink = (userInfo = {user:{}}) => {
 
     bridge.callHandler('nativeEvent', {
       event: 'shareLink',
       params: {
         // shareLinkParams:{
         title: `市值风云创作者百万补贴`,
         desc: '全民创作计划火爆进行中，月月可得3000元现金奖励',
         thumbUrl: 'https://file.wogoo.com/app/logo/logo6.png',
         linkUrl: process.env.REACT_APP_DEMAND_URL + 'active_130',
         // }
       }
     })
   }
  function handleScroll(e) {
    let footer = document.getElementById('foot_more');
    if(footer) {
      // if(window.scrollY >=20) {
      //   footer.classList.add('footer-freeclass-block');
      // }else {
      //   footer.classList.remove('footer-freeclass-block');
      // }
      var viewportHeight = window.innerHeight;
      // 获取整个文档的高度
      var documentHeight = document.documentElement.scrollHeight;
      // 获取当前垂直滚动的距离
      var scrollPosition = window.scrollY || window.pageYOffset;
  
      // 判断是否滚动到底部前160px
      if (documentHeight - (viewportHeight + scrollPosition) <= 160) {
          console.log('滚动到了距离底部160px的位置');
          footer.classList.add('footer-freeclass-block');
          // 在这里可以放置你想要执行的代码
      } else {
        footer.classList.remove('footer-freeclass-block');
      }
    }
   
  }
  useEffect(()=>{
    window.addEventListener('scroll', handleScroll);
    return   window.addEventListener('scroll', null);
  }, [])


  return(
    
  <Container style={isStorm ? {} : {paddingTop: 0}} ref={bodyContainer}>
    {
      isStorm &&  activeList === 1  && <Header 
        title={'市值风云百万创作奖金'} 
        right={
          <img 
            onClick={
              ()=>setShareLink()
            } 
            src={bwmodel.theme === '0' ? require(`@/img/share.png`):require(`@/img/share_dark.png`)} 
            className="share-img"
            alt=''
          />
        }
      />
    }
    {/* {
      isStorm &&  activeList === 2  && <Header   title={'优秀创作者'}/>
    } */}
    {
      isStorm &&  activeList === 3  && <Header title={'创作收入榜'} />
    }

    {
     activeList === 1 &&  <div className='container_active1'>
  
      <Reward token={token} />

      <Explain  ref={ruleRef} token={token} ></Explain>
      <div className='timeCard'>
        <div className='title'>活动时间</div>
        <div className='time_box'>
          <div >
            <div className='header'>本期时间</div>
            <div>{rankDate.firstDayOfMonth}-{rankDate.lastDayOfMonth}</div>
          </div>
          
          <img src={require('./image/back.png')} alt='' />
          <div>
            <div className='header'>奖项结算时间</div>
            <div>{rankDate.time}</div>
          </div>
          <img src={require('./image/back.png')} alt=''/>
          <div>
            <div className='header'>下期时间</div>
            <div>{rankDate.firstDayOfNextMonth}-{rankDate.lastDayOfNextMonth}</div>
          </div>
          </div>
      </div>

      <Awardbox className='award_box'>
        <div className='title title1'> 优秀创作者奖</div>
        <div className='awardbox_subtitle'>发布一篇含股票/基金/可转债的内容即自动参与</div>

        {/* <Slider
          {...settings} 
          autoplay={true}
          initialSlide={0}
        > */}
         
        <div className='card_boxs'>

        <Participate ref={participateRef} userInfo={userInfo} goEidt={goEidt} token={token} />
        <Card className='card1'>
          <div className="title">
            创作奖励 
            {/* <span className="sub_title"
            
              onClick={()=> {
                console.log(participateRef);
                if(!token)  {
                  return handleLogin();
                  
                }
                participateRef.current.show();
               
              }}
                
              >原创享3倍创作分</span>  */}
            <div  className="sub_title"><img  
            onClick={()=> {
                console.log(participateRef);
                if(!token)  {
                  return handleLogin();
                  
                }
                participateRef.current.show();
               
              }} src={require('./imgs/Group.png')} alt=""/></div>
              
          </div>
          <div className='subtitle'>
          本期「创作分」前20名作者 按名次瓜分<span className='red'>10000元</span>
          </div>
          <div className='tips'>
            优质内容规则：<span className='red'
            onClick={()=> {ruleRef.current.show();}}
          >查看详情>>> </span>
          </div>
          <img className='award1png' src={require('./image/award1.png')} alt='' />
        </Card>
        <Card className='card1'>
          <div className="title">
            当前排名 <span>最终上榜创作者将得奖励</span> 
          </div>
          <div className='table_header'>
            <div>名次</div>
            <div className='nickname'>名称</div>
            <div className='score'>创作分</div>
          </div>
          {
            userList.length >0 && userList.map((it,index) => {
              return  <div className='table_item' 
                onClick={()=> {
                  jumpTo(`storm://app/userzone?userID=${it.author.userId}&userName=${it.author.nickname}`)
                }}
              >
                <div className='rank'>{index + 1}</div>
                <div className='nickname'> <img src={it.author.avatar}  alt=''/> {it.author.nickname}</div>
                <div className='score'>{it.hot}</div>
              </div>
            })
          }
          {
            userList.length === 0 && <div className='empty'>内容为空</div>
          }
          <div className='more' onClick={()=> {
            setActiveList(2);
          }} >查看更多</div>
          {
            !havePoints  &&  <div className='table_tips' onClick={
              () => {
                goEidt('')
              }
            }>你暂未参与活动,去参与>></div>
          }
          {
             // TODO: 不同排名显示不同
             havePoints && (selfRank === 0 || selfRank > 50 )&& <div className='table_tips' onClick={ () => {
                goEidt('')
              }
            }>目前排名：50+，再发内容可拿奖</div>
          }
       
       {
             // TODO: 不同排名显示不同
             selfRank > 0 && selfRank <= 50 && <div className='table_tips'
              onClick={ () => {
                if(selfRank > 20) {
                  goEidt('')
                }
              }
            }
             >
             { 
              selfRank === 1 ? '目前排名：1，预计可得3000元'
              : selfRank === 2 ? '目前排名：2，预计可得1500元'
              : selfRank === 3 ? '目前排名：3，预计可得1000元'
              : (selfRank > 3  &&  selfRank < 11)? `目前排名：${selfRank}，预计可得500元`
              : (selfRank > 10  &&  selfRank < 16) ?  `目前排名：${selfRank}，预计可得200元`
               : (selfRank > 15  &&  selfRank < 21 )?  `目前排名：${selfRank}，预计可得周边4选1`:`目前排名：${selfRank}，再发内容可拿奖`
             }
              </div>
          }
        </Card>
        </div>
        {/* </Slider> */}
      </Awardbox>


      <Awardbox className='award_box'>
        <div className='title title2'>热点话题奖</div>
        <div className='awardbox_subtitle'>发布一篇含推荐话题的内容即自动参与</div>

        {/* <Slider
          {...settings} 
          autoplay={true}
          initialSlide={0}
        > */}
          <div className='card_boxs'>
      
         
        <Card className='card1'>
          <div className="title">
            创作奖励 
          </div>
          <div className='subtitle '>
          参与推荐话题综合排名前10名的作者即可共同瓜分<span className='red'>1000元</span>
          </div>
          <div className='tips'>
            优质内容规则：<span className='red'
            onClick={()=> {ruleRef.current.show();}}
          >查看详情>>> </span>
          </div>
          <img className='award1png'  src={require('./image/award2.png')} alt='' />
          {/* <div className='tips_flex'>
            <div className='tips'>
              <div style={{color:"#000",marginBottom: '5px'}}><b>热点内容：</b></div>
              <div>根据内容与话题主题相关程度（50%）、 内容质量情况（30%） 内容互动数据（20%） 等综合评定。</div>
              <div className='red'
                onClick={()=> {
                  ruleRef.current.show();
              }}
              >查看详情>></div> 
            </div>
            <img src={require('./image/award2.png')} alt='' />
          </div> */}
        </Card>
        <Card className='card1'>
          <div className="title">推荐话题  <span>都可参与</span></div>
          {
            topicList.map(item => {
              return <div className='topic_item' onClick={(event)=>{
                event.stopPropagation();
                jumpTo(`storm://app/topic/detail?name=${item.topicName}`)
              }}> 
              <div className='topic_item_title'>
                <div className='topic_item_left'> <span> #</span>{item.topicName}</div>
                <div className="topic_item_right"
                  onClick={(event)=> {
                    event.stopPropagation();
                    goEidt(item.topicName)
                  }}
                >
                    去发布
                </div>
              </div>
              <div className='desc'>{item.topicDesc}</div>
            </div>
            })
          }
          <div className='more'
            onClick= {()=> {
              jumpTo(`/active_130/create`);
            }}
          >查看更多</div>
        </Card>
        </div>
        {/* </Slider> */}
      </Awardbox>
      <Awardbox className='award_box'>
        <div className='title title3'>签约作者奖</div>
        <div className='awardbox_subtitle'>完成对应入驻任务即可获得</div>
        <div className='tooltip_box'>
          <div className='tooltip'>如果你已是其他平台的优质创作者</div>
          <div className='tooltip'>如果你想在平台长期输出原创风格内容</div>
          <div className='tooltip'>如果你的内容常常上社区热榜</div>
          <img className='chat' 
           onClick={()=> {
            // 私信	storm://app/multi/im/sessionDetails？sessionId=${}&nickname=${}
              // jumpTo('https://m.wogoo.com/serviceCode');
              jumpTo(`storm://app/userzone?userID=172ec6b9e99c496aa68852b76badca47&userName=风云活动君`)
            }} 
          src={require('./image/chat.png')} alt=''/>
        </div>  
      </Awardbox>
      <div className='foot-tips'>
      <div className='foot_more'
        id='foot_more' 
          onClick={()=> {
            goEidt('')
          }}
        >发作品 拿奖品</div>
        <div className='link'
          onClick={()=> {
            ruleRef.current.show();
          }}
        >更多规则说明>>></div>
        <div className='tips'>本活动最终解释权归市值风云平台所有</div>

      </div> 
    
     
      {/* <button onClick={()=>goEidt(1)}>goEidt</button> */}
    </div>
  }
{
  activeList === 2 && 
  <div >
    <Content />  
  </div>

}
{
  activeList === 3 && 
  <Originator />  
}
      <Footer className="footer">
        <div className="btns">
          <div className={`active position${activeList}`}></div>
          <div className={activeList===1?'highlight':''} onClick={()=> {setActiveList(1)}}>活动首页</div>
          
          <div  className={activeList===2?'highlight':''}  onClick={()=> {
            handleUploadTrace('Million_StocksRanking_Exposure', 'visitor');
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: 'smooth'
            });
            setActiveList(2)
            }}
          >创作者榜单</div>
          <div  className={activeList===3?'highlight':''}  onClick={()=> {
            handleUploadTrace('Million_RevenueList_Exposure', 'visitor');
            setActiveList(3)
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: 'smooth'
            });
          }
            
          }>创作收入榜</div>
        </div>
      </Footer>

      {
        !isStorm && <OpenApp   url={`${process.env.REACT_APP_DEMAND_URL}active_130`}></OpenApp>
      }
      {/* <ShareModal ref={shareRef} onShareClick={handleShareClick}/> */}
  </Container>
    )

}

const mapStateToProps = (state) => ({
  token: state.user.accessToken 
});
export default React.memo(connect(mapStateToProps)(Million))



const Container = styled.div`


@keyframes buttonAnimation {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(1);
    }
}
  max-width: 100%;
  overflow: hidden;
  background-color: #F7D9B8;
  padding-bottom: 100px;
  padding-top: 44px;
  @supports (bottom: constant(safe-area-inset-bottom)){
    padding-bottom:  calc(constant(safe-area-inset-bottom) + 100px);
  }
  @supports (bottom: env(safe-area-inset-bottom)){
    padding-bottom:  calc(env(safe-area-inset-bottom) + 100px);
     
  }
  min-height: 100vh;
  .container_active1 {
    max-width: 100%;
    padding-top: 144px;
    box-sizing: border-box;
    background-image: url(${bg1});
    background-size: 100%;
    background-repeat: no-repeat;
  }
  .bg-container {
    img {
      width: 100%;
    }
  }
  img {
    max-width: 100%;
  }
  .timeCard {
    background-image: url(${bg2});
    background-repeat: no-repeat;
    background-size: contain;
    margin: 0vw auto 0;
    width: 93.3vw;
    height: 27vw;
    text-align: center;
    .title {
      font-weight: 900;
      font-size: 16px;
      color: #FFF5EA;
      text-align: center;
      line-height: 7.7vw;
     
    }
   
    .header {
      height: 24px;
      background: #C63711;
      border-radius: 12px;
      line-height: 24px;
      color: #FFF5EA;
      font-weight: bold;
      padding: 0px 10px;
      text-align: center;
      margin-bottom: 8px;
    }
    .time_box {
      display: flex;
      justify-content: space-between;
      height: 16.5vw;
      background: #FFF5EA;
      border-radius: 8px;
      margin: 0px 1.6vw;
      padding: 0 10px;
      box-sizing: border-box;
      align-items: center;
      color: #000;
    }
    img {
      width: 10px;
      align-self: top;
    }
  }
  .foot_more {
    width: 215px;
    height: 40px;
    background: #C63711;
    border-radius: 20px;
    text-align: center;
    line-height:40px;
    color: #FFF5EA;
    margin: 5px auto;
    font-size: 22px;
    font-weight: bolder;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 80px;
    z-index:10;
   
    animation: buttonAnimation 1s forwards infinite;
    &.footer-freeclass-block {
      position: relative;
      bottom: 0;
    }
  }
  .foot-tips {
    margin-top: 20px;
    text-align: center;
    .more {
      
    }
    .link {
      font-family: Alibaba PuHuiTi;
      font-weight: bold;
      font-size: 17px;
      color: #C63711;
      margin-top: 16px;

    }
    .tips {
      font-weight: 500;
      font-size: 11px;
      color: #656565;
    }
  }
`
const Footer = styled.div`

 position: fixed;
  z-index: 100;
  bottom: 5vw;
  width: 100%;
  @supports (bottom: constant(safe-area-inset-bottom)){
    bottom: constant(safe-area-inset-bottom)!important;
  }

.btns {
  display: flex;
  justify-content: space-between;
  height: 30px;
  border-radius: 15px;
  box-sizing: content-box;
  border: 1px solid #C63711;
  width: 96vw;
  margin: auto;
  background: #FFF5EA;
  position: relative;
  >div {
    position: relative;
    z-index: 10;
    flex: 1;
    text-align: center;
    line-height:30px;
    width: 33%;
    color: #C63711;
    &.highlight {
      color: #FFF5EA;
    }
  }
  
  .active {
    position: absolute;
    z-index:9;
    width: 33.33%;
    border-radius: 15px;
    height: 30px;
     background: #C63711;
     transition: all 0.25s linear;
     &.position1 {
        left: calc(-1px);
     }
      &.position2 {
        left:33%;
        // left: calc(33% + 0px);
     }
      &.position3 {
        left:66.7%;
        //  left: calc(66.7% + 0px);
     }
   }
`

const Awardbox = styled.div`
  width: 93.34vw;
  height: 85.67vw;
  margin: 10px auto;
  background-image: url(${awardImg});
  background-repeat: no-repeat;
  background-size: contain;
  padding: 10px;
  overflow: scroll;
  box-sizing: border-box;
  position: relative;
  .card_boxs {
    width: 100%;
    overflow-x: scroll;
    display: flex;

    scrollbar-width: none;
   &::-webkit-scrollbar {
        display: none;
    }

  }
  .title {
    font-weight: 800;
    font-size: 6vw;
    color: #FFF5EA;
    line-height: 8.1vw;
    &.title1, &.title2, &.title3{
      padding-left: 50px;
      background-repeat: no-repeat;
      background-size: contain;
    }
    &.title1 {
      background-image: url(${title1});
    }
    &.title2 {
      background-image: url(${title2});
    }
    &.title3 {
      background-image: url(${title3});
    }
  }
  .awardbox_subtitle {
    font-weight: 500;
    font-size: 4vw;
    color: #F7D9B8;
    line-height: 4.3vw;
    font-style: italic;
    padding: 1.5vw 0;
  }
  .card_box {
    display: flex;
    overflow: scroll;
  }
.tooltip_box {
  margin-top: 2vw;
  position: relative;
  background: #FFF5EA;
  padding: 4.8vw 4vw;
  border-radius: 20px;
  .chat {
    position: absolute;
    right: 10px;
    bottom: 10px;
    width 23.5vw;
    height: 23.4vw;
    z-index: 10;
  }
}
.tooltip {
  display: inline-block;
  margin-bottom: 7.4vw;
  position: relative;
  background-color: #C63711;
  color: white;
  padding: 2.7vw;
  font-size: 3.7vw;
  border-radius: 4px;
}

/* 创建三角形 */
.tooltip::after {
  content: '';
  position: absolute;
  top: 9.6vw; /* 将三角形置于上方 */
  left: 20px;   /* 调整三角形的位置 */
  border-width: 10px; /* 控制三角形大小 */
  border-style: solid;
  border-color: #C63711 transparent transparent transparent; /* 设置三角形的颜色和透明边 */
}

`   
const Card = styled.div`
  // flex-wrap: nowrap;
  flex-shrink: 0;
  margin-right: 10px;
  &.card1 {
    width: 64.53vw !important;
    height: 62.27vw;
    padding: 4vw 3vw;
    box-sizing: border-box;
    background-image: url(${cardImg});
    background-repeat: no-repeat;
    background-size: contain;
    .empty {
      line-height: 40px;
      text-align: center;
      font-size: 12px;
      color: #6B6B6B;
    }
    .award1png {
      display: block;
      margin:0.5vw auto;
      width: 40vw;
    }
  }
  .tips_flex {
    display:flex;
    img {
      width: 82px;
    }
  }
  .title {
    font-family: Alibaba PuHuiTi;
    font-weight: 800;
    font-size: 5.6vw;
    color: #C63711;
    padding-bottom:  5vw;
    line-height: 1;
    display:flex;
    justify-content: space-between;
    >span {
      font-weight: bold;
      font-size: 11px;
      color: #000000;
      align-self: end;
    }
    .sub_title {
     
      flex: 1;
      img {
        margin-left: 10px;
       height: 22px;
      }
    }
  }
  .subtitle {
    font-weight: bold;
    font-size: 14px;
    font-style: normal;
    color: #000000;
    .red{
      color:#C63711;
    }
  }
  .subtitle2 {
    font-weight: bold;
    font-size: 16px;
    color: #000000;
    line-height: 19px;
    margin-bottom: 5px;
  }
  .tips {
    font-family: Alibaba PuHuiTi;
    font-weight: 400;
    font-size: 12px;
    color: #6B6B6B;
    line-height: 15px;
    .red{
      color:#C63711;
    }
  }

  .table_header {
    display: flex;
    justify-content: space-between;
    font-weight: 500;
    font-size: 10px;
    color: #707070;
    margin-bottom: 15px;
 
  }
  .table_item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    color: #231815;
    .nickname {
      text-align: left;
      flex: 1;
      display: flex;
      img {
        margin-right: 10px;
        width: 17px;
        height: 17px;
        border-radius:50%;
      }
    }
    .rank {
      width:25px;
      text-align: center;
    }
    .score {
      width: 25%;
      text-align: right;
       font-family: monospace; /* 使用等宽字体 */
    }
  }
  .table_tips {
    font-size: 10px;
    color: #C63711;
    text-align: center;
  }
  .topic_item {
    + .topic_item {
        margin-top: 3vw;
    }

    .topic_item_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .topic_item_left {
        font-weight: bold;
        font-size: 16px;
        color: #000000;
        display: inline-block;
        max-width:140px;
        white-space: nowrap;        /* 禁止文本换行 */
        overflow: hidden;           /* 隐藏超出容器的文本 */
        text-overflow: ellipsis;    /* 使用省略号表示溢出的文本 */
        >span {
          margin-top:9px;
          color: #C63711;
          font-bold: bolder;
        }
      }
    }
    .topic_item_right {
      width: 50px;
      height: 18px;
      background: #C63711;
      border-radius: 9px;
      line-height: 18px;
      text-align: center;
      font-weight: bold;
      font-size: 11px;
      color: #FFF5EA;
    }
    .desc {
      margin-top: 5px;
      font-size: 10px;
      color: #767676;
      white-space: nowrap;        /* 禁止文本换行 */
      overflow: hidden;           /* 隐藏超出容器的文本 */
      text-overflow: ellipsis;    /* 使用省略号表示溢出的文本 */
    }
  }
  .more {
    width: 114px;
    height: 26px;
  
    background: #C63711;
    border-radius: 13px;
    text-align: center;
    line-height:26px;
    color: #FFF5EA;
    margin: 5px auto;
  }
`



// WEBPACK FOOTER //
// ./src/views/activity_130/index.js